import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'
import { useRouter } from 'next/router'

import { getIsUserCreated } from 'src/effects/User/selectors'
import { createUserRequestAction, resetUserAction } from 'src/effects/User/actions'

import { MIN_LENGTH } from 'client/helpers/Form/constants'
import { useMarket } from 'src/hooks/useMarket'
import { useSystem } from 'src/hooks/useSystem'
import { routes } from 'src/constants/routes'
import { validateEmail, validatePassword } from 'client/helpers/Form'
import { LoginAndSignUpForm } from '../LoginAndSignUpForm'

import styles from './styles.module.css'

type ErrorsType = {
  email: ReturnType<typeof validateEmail>
  password: ReturnType<typeof validatePassword>
}

interface IFormSignUpProps {
  returnUrl?: string | null
}

const FormSignUp = ({ returnUrl = '' }: IFormSignUpProps) => {
  const intl = useIntl()
  const router = useRouter()
  const dispatch = useDispatch()

  const { market, language } = useMarket()
  const { apiHostName } = useSystem()
  const isUserCreated = useSelector(getIsUserCreated)

  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [errors, setErrors] = useState<ErrorsType>({
    email: null,
    password: null,
  })

  function validForm() {
    const error = {
      email: validateEmail(email, { required: true }),
      password: validatePassword(password, { min: MIN_LENGTH, required: true }),
    }
    setErrors(error)
    return !error.email && !error.password
  }

  function handleSubmitForm(event: React.FormEvent) {
    event.preventDefault()
    event.stopPropagation()

    if (!validForm()) {
      return
    }

    dispatch(
      createUserRequestAction({
        data: { email, password, market, language },
        hostname: apiHostName,
      })
    )
  }

  const redirect = () => {
    if (returnUrl) {
      const urlToRedirect = decodeURIComponent(returnUrl)
      router.replace(urlToRedirect)
    } else {
      router.push({ pathname: routes.myDetails.pathname })
    }
  }

  if (isUserCreated) {
    resetUserAction()
    redirect()
    return null
  }

  const title = intl.formatMessage({ id: 'global.sign-up' })
  const text = `${intl.formatMessage({ id: 'global.signup-body2' })} ${intl.formatMessage({
    id: 'global.login-body',
  })}`

  return (
    <div className={styles.signUpBase}>
      <div className={styles.content}>
        <LoginAndSignUpForm
          title={title}
          text={text}
          email={email}
          setEmail={setEmail}
          password={password}
          setPassword={setPassword}
          handleSubmitForm={handleSubmitForm}
          errors={errors}
          showTerms={!isUserCreated}
          isSignUp
        />
      </div>
    </div>
  )
}

export default FormSignUp
